<template>
    <div>
        <draggable :group="'obj-' + id" :list="data" class="list-group" handle=".handle">
            <div v-for="(item, idx) in data" :key="idx">
                <b-input style="width:300px; display:inline-block" v-model="item.key"></b-input> -> 
                <b-input style="width:300px; display:inline-block" v-model="item.value"></b-input>
                <b-button variant="link" class="handle"><i class="fas fa-arrows-alt"></i></b-button>
                <b-button variant="link" @click="del(idx)"><i class="fas fa-trash"></i></b-button>
            </div>
        </draggable>

        <b-button variant="link" @click="add()"><i class="fas fa-plus"></i></b-button>

    </div>

</template>

<script>
    import uniqueId from "lodash.uniqueid";
	import draggable from "vuedraggable";

    import store from "../store";
import { isArray } from "underscore";

	var clone = require("clone");

    export default {
        name: "obj_editor",
        components: {
            draggable
        },
        props: {
            start_data: {
				type: Object,
				default: () => {}
            },
            type: {
                default: "text"
            }
        },
        data: function () {
            return {				
                id: uniqueId(""),
                data: []
            };
		},
        watch: 
        {
			data: {
				deep: true,
				handler() {
                    var data = {};
                    for (var i = 0; i < this.data.length; i++)
                    {
                        data[this.data[i].key] = this.data[i].value
                    }
					this.$emit("update", data);
				},
			},
        },
		methods: {
            get_data()
            {
                var data = {};

                for (var i = 0; i < this.data.length; i++)
                {
                    data[this.data[i]["key"]] = this.data[i]["value"];
                }

                return data;
            },
            save()
            {
                var data = {};

                for (var i = 0; i < this.data.length; i++)
                {
                    data[this.data[i]["key"]] = this.data[i]["value"];
                }

                return data;
            },
            load(data)
            {
                if (isArray(data))
                {
                    this.data = data;
                }
                else
                {
                    this.data = [];
                    this.set(data);
                }
            },
            del(idx)
            {
                this.data.splice(idx, 1);
            },
            add()
            {
                this.data.push({key: "", value: ""});
            },
            set(data)
            {
                var keys = Object.keys(data);
                for (var i = 0; i < keys.length; i++)
                {
                    this.data.push({
                        key: keys[i],
                        value: data[keys[i]]
                    })
                }
            }
        },
		mounted: function () {
            var self = this;

            if (this.start_data)
            {
                var keys = Object.keys(this.start_data);
                for (var i = 0; i < keys.length; i++)
                {
                    this.data.push({
                        key: keys[i],
                        value: this.start_data[keys[i]]
                    })
                }
            }
		},
    }

</script>